"use client";
import { useNow, useTranslations } from "next-intl";
import { Sparkles } from "lucide-react";
import { isPromotionActive } from "@/lib/listing/promotion";
import type { ListingPromotionWindow } from "@/lib/types/search";
import { cn } from "@/lib/utils";

export default function ListingPromotionBadge({
  promotion,
  className,
}: {
  promotion?: ListingPromotionWindow | null;
  className?: string;
}) {
  const now = useNow({ updateInterval: 1000 });
  const t = useTranslations("listing");
  if (!isPromotionActive(promotion, now)) return null;
  return (
    <span
      className={cn(
        "inline-flex w-fit items-center gap-1.5 rounded-full border border-secondary bg-secondary px-2.5 py-1 text-[11px] font-semibold text-secondary-foreground shadow-sm",
        className,
      )}
      title={t("promotion-explanation")}
    >
      <Sparkles aria-hidden className="size-3" />
      {t("promoted")}
    </span>
  );
}
